angular
.module( 'ribytRsvpApp' )
.directive( 'bonusByt', function ( $sessionStorage, $rootScope, $http, $state, ENV, $sce ) {
    return {
        'restrict': 'E',
        'scope': {
            'currentByt': '@'
        },
        'templateUrl': 'views/directives/itinerary/bonusByt.html',
        'link': function ( scope, element, attrs ) {
            // we give full trust that the code in our database is safe. Otherwise, we get some other issues with styling not being displayed properly
            scope.trustedHtml = function (plainText) {
                return $sce.trustAsHtml(plainText);
            }

            var byt = JSON.parse( scope.currentByt );
            var newByt = {};

            _.each( byt, function ( b, key ) {
                newByt[key] = b;
            } );
            scope.byt = newByt;
            scope.preview = $rootScope.preview;
            scope.pdfView = _.get( $sessionStorage, 'pdfView', false );

            scope.isAccepted = function ( passedByt ) {
                var data = {
                    bytID: passedByt.bytID.id,
                    status: passedByt.isAccepted
                };
                $http.put( ENV.apiEndpoint + '/ribyt/rsvp/setBytStatus/' + $sessionStorage.inviteHash, data )
                        .then( function setBytStatus ( ) {
                            // update the invite session storage/scope just in case they refresh
                            var invitation = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );
                            // find the byt in the invite
                            var modifiedBytIndex = _.findIndex( _.get( invitation, 'byts' ), {'bytID.id': _.get( passedByt, 'bytID.id' )} );

                            // set the isAccepted value to the invite
                            _.set( invitation, 'byts[' + modifiedBytIndex + '].isAccepted', passedByt.isAccepted );
                            // save the results in $sessionStorage
                            _.set( $sessionStorage, 'invitation', $rootScope.encryptInvite( invitation ) );
                        }, function setBytStatusError ( error ) {
                        } );
            };
        }
    };
} );
